/**
 * @generated SignedSource<<83960bb0e7ad32d0d97c3cf7f7ee8428>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RevokeDeviceInput = {
  clientMutationId?: string | null | undefined;
  deviceId: string;
};
export type OpsDevicesPageRevokeMutation$variables = {
  input: RevokeDeviceInput;
};
export type OpsDevicesPageRevokeMutation$data = {
  readonly revokeDevice: {
    readonly device: {
      readonly id: string;
      readonly revokedAt: any | null | undefined;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsDevicesPageRevokeMutation = {
  response: OpsDevicesPageRevokeMutation$data;
  variables: OpsDevicesPageRevokeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RevokeDevicePayload",
    "kind": "LinkedField",
    "name": "revokeDevice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Device",
        "kind": "LinkedField",
        "name": "device",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revokedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsDevicesPageRevokeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsDevicesPageRevokeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5f76543f62961606ef40dfe20fbaa3cd",
    "id": null,
    "metadata": {},
    "name": "OpsDevicesPageRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation OpsDevicesPageRevokeMutation(\n  $input: RevokeDeviceInput!\n) {\n  revokeDevice(input: $input) {\n    device {\n      id\n      revokedAt\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7768d4e554217946311f7bdc78026309";

export default node;
